import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const GoogleSheets = (props: TIconProps): ReactElement => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="googlesheets_mask0_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask0_439_72702)">
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L15.4336 4.61736L12.4149 0.391174Z"
        fill="hsl(from hsl(150 82% 34%) h s 53%)"
      />
    </g>
    <mask
      id="googlesheets_mask1_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask1_439_72702)">
      <path
        d="M5.17004 13.3716V22.1259H14.8299V13.3716H5.17004ZM9.39623 20.9184H6.37753V19.4091H9.39623V20.9184ZM9.39623 18.5034H6.37753V16.9941H9.39623V18.5034ZM9.39623 16.0885H6.37753V14.5791H9.39623V16.0885ZM13.6224 20.9184H10.6037V19.4091H13.6224V20.9184ZM13.6224 18.5034H10.6037V16.9941H13.6224V18.5034ZM13.6224 16.0885H10.6037V14.5791H13.6224V16.0885Z"
        fill="hsl(from hsl(150 82% 34%) h s 95%)"
      />
    </g>
    <mask
      id="googlesheets_mask2_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask2_439_72702)">
      <path
        d="M12.9447 7.10626L19.6598 13.8199V7.63605L12.9447 7.10626Z"
        fill="url(#googlesheets_paint0_linear_439_72702)"
      />
    </g>
    <mask
      id="googlesheets_mask3_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask3_439_72702)">
      <path
        d="M12.4149 0.391174V5.82485C12.4149 6.82555 13.2254 7.63607 14.2261 7.63607H19.6598L12.4149 0.391174Z"
        fill="hsl(from hsl(150 82% 34%) h s 77%)"
      />
    </g>
    <mask
      id="googlesheets_mask4_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask4_439_72702)">
      <path
        d="M2.15131 0.391174C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V2.35333C0.340088 1.35716 1.15514 0.54211 2.15131 0.54211H12.4149V0.391174H2.15131Z"
        fill="white"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="googlesheets_mask5_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask5_439_72702)">
      <path
        d="M17.8486 26.8049H2.15131C1.15514 26.8049 0.340088 25.9898 0.340088 24.9937V25.1446C0.340088 26.1408 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1408 19.6598 25.1446V24.9937C19.6598 25.9898 18.8448 26.8049 17.8486 26.8049Z"
        fill="hsl(from hsl(150 82% 34%) h s 48%)"
      />
    </g>
    <mask
      id="googlesheets_mask6_439_72702"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="27"
    >
      <path
        d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
        fill="white"
      />
    </mask>
    <g mask="url(#googlesheets_mask6_439_72702)">
      <path
        d="M14.2261 7.63605C13.2254 7.63605 12.4149 6.82553 12.4149 5.82483V5.97576C12.4149 6.97647 13.2254 7.78699 14.2261 7.78699H19.6598V7.63605H14.2261Z"
        fill="hsl(from hsl(150 82% 34%) h s 47%)"
      />
    </g>
    <path
      d="M12.4149 0.391174H2.15131C1.15514 0.391174 0.340088 1.20623 0.340088 2.2024V25.1446C0.340088 26.1407 1.15514 26.9558 2.15131 26.9558H17.8486C18.8448 26.9558 19.6598 26.1407 19.6598 25.1446V7.63607L12.4149 0.391174Z"
      fill="url(#googlesheets_paint1_radial_439_72702)"
    />
    <defs>
      <linearGradient
        id="googlesheets_paint0_linear_439_72702"
        x1="348.737"
        y1="64.75"
        x2="348.737"
        y2="678.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(150 82% 34%) h s 48%)" />
        <stop offset="1" stopColor="hsl(from hsl(150 82% 34%) h s 48%)" />
      </linearGradient>
      <radialGradient
        id="googlesheets_paint1_radial_439_72702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.5459 52.8946) scale(3115.28 3115.28)"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
